
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M22 16.051V7.5C22 5.019 19.981 3 17.5 3h-11A4.505 4.505 0 002 7.5v8.551c-1.14.232-2 1.242-2 2.449C0 19.878 1.122 21 2.5 21h19c1.378 0 2.5-1.122 2.5-2.5 0-1.207-.86-2.217-2-2.449zM6.5 4h11C19.43 4 21 5.57 21 7.5V16h-5.5a.504.504 0 00-.354.146l-.854.854H9.706l-.854-.854A.5.5 0 008.498 16H3V7.5C3 5.57 4.57 4 6.5 4zm15 16h-19c-.827 0-1.5-.673-1.5-1.5S1.673 17 2.5 17h5.793l.854.854a.5.5 0 00.354.146h5c.133 0 .26-.053.354-.146l.854-.854h5.793c.827 0 1.5.673 1.5 1.5s-.673 1.5-1.5 1.5H21.5zm-14-6c1.378 0 2.5-1.122 2.5-2.5v-3C10 7.122 8.878 6 7.5 6A2.503 2.503 0 005 8.5v3C5 12.878 6.122 14 7.5 14zM6 8.5C6 7.673 6.673 7 7.5 7S9 7.673 9 8.5v3c0 .827-.673 1.5-1.5 1.5S6 12.327 6 11.5v-3zM16.5 14c1.378 0 2.5-1.122 2.5-2.5v-3C19 7.122 17.878 6 16.5 6A2.503 2.503 0 0014 8.5v3c0 1.378 1.122 2.5 2.5 2.5zM15 8.5c0-.827.673-1.5 1.5-1.5s1.5.673 1.5 1.5v3c0 .827-.673 1.5-1.5 1.5s-1.5-.673-1.5-1.5v-3zm-4.335-.006a.499.499 0 01-.035-.706l1.471-1.624c.281-.311.9-.082.9.335v7a.5.5 0 01-1 0V7.764l-.629.695a.5.5 0 01-.706.035h-.001z","fill":"#000C1F"}})])
          )
        }
      }
    